import React from "react";
import { useModalProductViewHook } from "./modal-product-view-hooks";

type ContextModalProductView = ReturnType<typeof useModalProductViewHook>;
export const ModalProductViewContext =
  React.createContext<ContextModalProductView | null>(null);

export function useContextModalProductView() {
  const context = React.useContext(ModalProductViewContext);

  if (!context) {
    throw new Error(
      "useContextModalProductView must be used within a ContextModalProductViewProvider",
    );
  }

  return context;
}
